import React from 'react';
import { Route, Switch } from 'react-router';
import Disclosure from '../../features/home/Disclosure';
import HomePage from '../../features/home/HomePage';
import ApplicationDetailedPageBySlug from '../../features/library/applicationDetailed/ApplicationDetailedPageBySlug';
import LibraryDashboard from '../../features/library/libraryDashboard/LibraryDashboard';
import ErrorComponent from '../common/errors/ErrorComponent';
import RedirectToPage from '../common/util/RedirectToPage';

export default function Routes() {
  return (
    <Switch>
      <Route path='/' exact component={HomePage} />
      <Route
        path='/library/:slug'
        exact
        component={ApplicationDetailedPageBySlug}
      />
      <Route
        path='/view/:slug'
        exact
        component={ApplicationDetailedPageBySlug}
      />
      <Route
        path={[
          '/lib',
          '/search',
          '/resources/:term1',
          '/resources/:term1/:term2',
          '/resources/:term1/:term2/:term3',
        ]}
        exact
        component={LibraryDashboard}
      />

      {/* <PrivateRoute
          path='/createApplication'
          component={ApplicationForm}
        />
        <PrivateRoute
          path={['/manage/:id', '/edit/:id']}
          component={ApplicationEditPage}
          key={key}
        />
        <PrivateRoute path='/sandbox' component={Sandbox} /> */}
      <Route path='/error' component={ErrorComponent} />
      {/* <PrivateRoute path='/account' component={AccountPage} />
        <PrivateRoute path='/profile/:id' component={ProfilePage} />
        <PrivateRoute path='/list' component={List} />
        <PrivateRoute path='/broken' component={BrokenLinks} /> */}
      <Route path='/go/:slug' component={RedirectToPage} />
      <Route path='/disclosure' component={Disclosure} />
      <Route
        render={() => (
          <ErrorComponent message="Sorry, I didn't find anything" />
        )}
      />
    </Switch>
  );
}
